import type { ItemKind, Lang, TranslationKey, TranslationTable } from './types'
import { params, state } from './state'

const LANG_KEY = 'been-web:lang'

export const translations: Record<Lang, TranslationTable> = {
  en: {
    htmlLang: 'en',
    eyebrow: 'Local-first map journal',
    exportBackup: 'Export backup',
    importBackup: 'Import backup',
    statsLabel: 'Map statistics',
    countries: 'Regions',
    logs: 'Logs',
    media: 'Media',
    selectCountry: 'Map items',
    clickCountry:
      'Select a region, zoom in manually, then click inside it to add a travel log, photo, or video.',
    noItems: 'No items here yet.',
    noNote: 'No note.',
    noDate: 'No date',
    loadingMap: 'Loading map...',
    couldNotLoadCountries: 'Could not load region shapes.',
    invalidCoordinates: 'Coordinates are outside valid ranges.',
    itemSaved: 'Map item saved locally.',
    mediaUnavailable: 'Media unavailable',
    deleteAllConfirm: 'Delete every saved map item and local media file?',
    backupImported: 'Backup imported.',
    backupFailed: 'Could not import this backup.',
    delete: 'Delete',
    edit: 'Edit',
    editItem: 'Edit map item',
    themeLabel: 'Theme',
    languageLabel: 'Language',
    drawerOpen: 'Map items',
    drawerClosed: 'Items',
    light: 'Light',
    dark: 'Dark',
    travelLog: 'Travel log',
    photo: 'Photo',
    video: 'Video',
    addItem: 'Add map item',
    type: 'Type',
    title: 'Title',
    note: 'Note',
    date: 'Date',
    file: 'Local file',
    mediaUrl: 'Public or Instagram URL',
    save: 'Save',
    cancel: 'Cancel',
    zoomHint: 'Zoom in closer for accurate pin placement.',
    countrySelectedHint: 'Region selected. Zoom in manually to add an item.',
    urlOrFileRequired:
      'Add a local file or public URL for photo/video items.',
  },
  pt: {
    htmlLang: 'pt-BR',
    eyebrow: 'Diário de mapa local-first',
    exportBackup: 'Exportar backup',
    importBackup: 'Importar backup',
    statsLabel: 'Estatísticas do mapa',
    countries: 'Regiões',
    logs: 'Logs',
    media: 'Mídias',
    selectCountry: 'Itens do mapa',
    clickCountry:
      'Selecione uma região, aproxime o zoom manualmente e clique dentro dela para adicionar log, foto ou vídeo.',
    noItems: 'Ainda não há itens aqui.',
    noNote: 'Sem nota.',
    noDate: 'Sem data',
    loadingMap: 'Carregando mapa...',
    couldNotLoadCountries: 'Não foi possível carregar as regiões.',
    invalidCoordinates: 'As coordenadas estão fora dos limites válidos.',
    itemSaved: 'Item salvo localmente.',
    mediaUnavailable: 'Mídia indisponível',
    deleteAllConfirm: 'Apagar todos os itens do mapa e mídias locais?',
    backupImported: 'Backup importado.',
    backupFailed: 'Não foi possível importar este backup.',
    delete: 'Excluir',
    edit: 'Editar',
    editItem: 'Editar item',
    themeLabel: 'Tema',
    languageLabel: 'Idioma',
    drawerOpen: 'Itens do mapa',
    drawerClosed: 'Itens',
    light: 'Claro',
    dark: 'Escuro',
    travelLog: 'Log de viagem',
    photo: 'Foto',
    video: 'Vídeo',
    addItem: 'Adicionar item',
    type: 'Tipo',
    title: 'Título',
    note: 'Nota',
    date: 'Data',
    file: 'Arquivo local',
    mediaUrl: 'URL pública ou do Instagram',
    save: 'Salvar',
    cancel: 'Cancelar',
    zoomHint: 'Aproxime o zoom para posicionar o pin com precisão.',
    countrySelectedHint:
      'Região selecionada. Aproxime o zoom manualmente para adicionar um item.',
    urlOrFileRequired:
      'Adicione um arquivo local ou uma URL pública para foto/vídeo.',
  },
}

/** Lookup the current-language string for a translation key. */
export function t(key: TranslationKey): string {
  return translations[state.lang][key] ?? translations.en[key] ?? key
}

/** Human-readable label for an item kind, in the current language. */
// export function kindLabel(kind: ItemKind): string {
//   if (kind === 'photo') return t('photo')
//   if (kind === 'video') return t('video')
//   return t('travelLog')
// }

export function loadLang(): Lang {
  const requested = params.get('lang')
  if (requested === 'en' || requested === 'pt') return requested
  const stored = localStorage.getItem(LANG_KEY)
  if (stored === 'en' || stored === 'pt') return stored
  return navigator.language?.toLowerCase().startsWith('pt') ? 'pt' : 'en'
}

export function setLang(lang: Lang): void {
  state.lang = lang
  localStorage.setItem(LANG_KEY, lang)
}
